import { render, staticRenderFns } from "./trains.vue?vue&type=template&id=1c9d87de"
import script from "./trains.vue?vue&type=script&lang=js"
export * from "./trains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports